import { render, staticRenderFns } from "./VAdministrationForm.vue?vue&type=template&id=4c5e9a58&"
import script from "./VAdministrationForm.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationForm.vue?vue&type=style&index=0&id=4c5e9a58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports